import React from 'react'
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material'
import { tableCellClasses } from '@mui/material/TableCell'
import { styled } from '@mui/material'

interface DataTableProps {
  col: any
  row: any
}

const StyledTableCell = styled(TableCell)({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
  },
})

const StyledTableRow = styled(TableRow)({
  '&.MuiTableRow-head': {
    backgroundColor: '#F1F1F1',
    borderRadius: '10px',
  },
})

const StyledTableBodyRow = styled(TableRow)({
  '&:last-child td, &:last-child th': {
    border: 0,
  },
})

function DataTable({ col, row }: DataTableProps) {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <StyledTableRow>
            {col.map(
              (item, index: number) =>
                item && (
                  <StyledTableCell align="center" key={`col-${index}`}>
                    {item}
                  </StyledTableCell>
                ),
            )}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {row.map(
            (rowItem, rowIndex: number) =>
              rowItem && (
                <StyledTableBodyRow key={`row-${rowIndex}`}>
                  {rowItem.map(
                    (dataItem, dataIndex: number) =>
                      dataItem && (
                        <StyledTableCell
                          align="center"
                          key={`row-data-${dataIndex}`}
                        >
                          {dataItem}
                        </StyledTableCell>
                      ),
                  )}
                </StyledTableBodyRow>
              ),
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default DataTable
